<template>
  <div class="auth-input-wrapper">
    <input
      :class="{error: !credentialsValid}"
      @input="clearErrors"
      v-model="value"
      type="password"
      id="login-password"
      maxlength="35"
      required
    >
    <label for="login-password">Hasło</label>
  </div>
</template>

<script>
export default {
  name: 'PasswordLoginInput',
  computed: {
    value: {
      get() {
        return this.$store.getters.loginPassword;
      },
      set(value) {
        this.$store.commit('updateLoginPassword', value);
      }
    },
    credentialsValid() {
      return this.$store.getters.loginCredentialsValid;
    }
  },
  methods: {
    clearErrors() {
      this.$store.dispatch('clearAllAuthErrors');
    }
  }
};
</script>
